// extracted by mini-css-extract-plugin
export default {"banner":"banner---gHix2","line":"line---sMZF_","previewNote":"previewNote---jrEDN","variantStatus":"variantStatus---KpI1t","variantStatusCustom":"variantStatusCustom---EQjQ7"};